import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Table, TableRow, TableHead, TableCell, TableBody, HeadCell, Button, DynamicIcon } from 'legion-ui';
import DataTableComponent from './component.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Tables are used to display tabular data using rows and columns`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Table, TableRow, TableHead, TableCell, TableBody, HeadCell, Button, DynamicIcon } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion have two variant of table`}</p>
    <h3><strong parentName="h3">{`Basic Table`}</strong></h3>
    <div className="padding:2rem; background-color: #F6F7FC;">
  <Table mdxType="Table">
    <TableHead mdxType="TableHead">
      <TableRow mdxType="TableRow">
        <HeadCell mdxType="HeadCell">No.</HeadCell>
        <HeadCell align="left" mdxType="HeadCell">Full Name</HeadCell>
        <HeadCell align="left" mdxType="HeadCell">Born</HeadCell>
        <HeadCell align="left" mdxType="HeadCell">Age</HeadCell>
        <HeadCell mdxType="HeadCell">Actions</HeadCell>
      </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
      <TableRow mdxType="TableRow">
        <TableCell align="center" mdxType="TableCell">1</TableCell>
        <TableCell mdxType="TableCell">Eric Clapton</TableCell>
        <TableCell mdxType="TableCell">Ripley, United Kingdom</TableCell>
        <TableCell mdxType="TableCell">77</TableCell>
        <TableCell style={{
              "display": "flex",
              "justifyContent": "center"
            }} mdxType="TableCell">
          <Button iconLeft={<DynamicIcon name="Edit" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
          <Button iconLeft={<DynamicIcon name="Trash2" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
        </TableCell>
      </TableRow>
      <TableRow mdxType="TableRow">
        <TableCell align="center" mdxType="TableCell">2</TableCell>
        <TableCell mdxType="TableCell">Adam Sandler</TableCell>
        <TableCell mdxType="TableCell">Brooklyn, New York, United States</TableCell>
        <TableCell mdxType="TableCell">56</TableCell>
        <TableCell style={{
              "display": "flex",
              "justifyContent": "center"
            }} mdxType="TableCell">
          <Button iconLeft={<DynamicIcon name="Edit" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
          <Button iconLeft={<DynamicIcon name="Trash2" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
        </TableCell>
      </TableRow>
      <TableRow mdxType="TableRow">
        <TableCell align="center" mdxType="TableCell">3</TableCell>
        <TableCell mdxType="TableCell">Jennifer Aniston</TableCell>
        <TableCell mdxType="TableCell">Sherman Oaks, Los Angeles, California, United States</TableCell>
        <TableCell mdxType="TableCell">53</TableCell>
        <TableCell style={{
              "display": "flex",
              "justifyContent": "center"
            }} mdxType="TableCell">
          <Button iconLeft={<DynamicIcon name="Edit" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
          <Button iconLeft={<DynamicIcon name="Trash2" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
        </TableCell>
      </TableRow>
      <TableRow mdxType="TableRow">
        <TableCell align="center" mdxType="TableCell">4</TableCell>
        <TableCell mdxType="TableCell">Ben Stiller</TableCell>
        <TableCell mdxType="TableCell">New York, New York, United States</TableCell>
        <TableCell mdxType="TableCell">56</TableCell>
        <TableCell style={{
              "display": "flex",
              "justifyContent": "center"
            }} mdxType="TableCell">
          <Button iconLeft={<DynamicIcon name="Edit" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
          <Button iconLeft={<DynamicIcon name="Trash2" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
        </TableCell>
      </TableRow>
      <TableRow mdxType="TableRow">
        <TableCell align="center" mdxType="TableCell">5</TableCell>
        <TableCell mdxType="TableCell">Brooklyn Decker</TableCell>
        <TableCell mdxType="TableCell">Dayton, Ohio, United States</TableCell>
        <TableCell mdxType="TableCell">35</TableCell>
        <TableCell style={{
              "display": "flex",
              "justifyContent": "center"
            }} mdxType="TableCell">
          <Button iconLeft={<DynamicIcon name="Edit" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
          <Button iconLeft={<DynamicIcon name="Trash2" mdxType="DynamicIcon" />} variant="transparent" mdxType="Button" />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Table>
  <TableHead>
    <TableRow>
      <HeadCell>No.</HeadCell>
      <HeadCell align="left">Full Name</HeadCell>
      <HeadCell align="left">Born</HeadCell>
      <HeadCell align="left">Age</HeadCell>
      <HeadCell>Actions</HeadCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow>
      <TableCell align="center">1</TableCell>
      <TableCell>Eric Clapton</TableCell>
      <TableCell>Ripley, United Kingdom</TableCell>
      <TableCell>77</TableCell>
      <TableCell style="display: flex; justify-content: center;">
        <Button iconLeft={<DynamicIcon name="Edit" />} variant="transparent" />
        <Button iconLeft={<DynamicIcon name="Trash2" />} variant="transparent" />
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell align="center">2</TableCell>
      <TableCell>Adam Sandler</TableCell>
      <TableCell>Brooklyn, New York, United States</TableCell>
      <TableCell>56</TableCell>
      <TableCell style="display: flex; justify-content: center;">
        <Button iconLeft={<DynamicIcon name="Edit" />} variant="transparent" />
        <Button iconLeft={<DynamicIcon name="Trash2" />} variant="transparent" />
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell align="center">3</TableCell>
      <TableCell>Jennifer Aniston</TableCell>
      <TableCell>Sherman Oaks, Los Angeles, California, United States</TableCell>
      <TableCell>53</TableCell>
      <TableCell style="display: flex; justify-content: center;">
        <Button iconLeft={<DynamicIcon name="Edit" />} variant="transparent" />
        <Button iconLeft={<DynamicIcon name="Trash2" />} variant="transparent" />
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell align="center">4</TableCell>
      <TableCell>Ben Stiller</TableCell>
      <TableCell>New York, New York, United States</TableCell>
      <TableCell>56</TableCell>
      <TableCell style="display: flex; justify-content: center;">
        <Button iconLeft={<DynamicIcon name="Edit" />} variant="transparent" />
        <Button iconLeft={<DynamicIcon name="Trash2" />} variant="transparent" />
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell align="center">5</TableCell>
      <TableCell>Brooklyn Decker</TableCell>
      <TableCell>Dayton, Ohio, United States</TableCell>
      <TableCell>35</TableCell>
      <TableCell style="display: flex; justify-content: center;">
        <Button iconLeft={<DynamicIcon name="Edit" />} variant="transparent" />
        <Button iconLeft={<DynamicIcon name="Trash2" />} variant="transparent" />
      </TableCell>
    </TableRow>
  </TableBody>
</Table>
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Data Table`}</strong></h3>
    <p>{`The Table component has a close mapping to the native `}<inlineCode parentName="p">{`<table>`}</inlineCode>{` elements. This constraint makes building rich data tables challenging.`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <DataTableComponent mdxType="DataTableComponent" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { Component } from 'react';
import { DataTable as DataTableComponent } from 'legion-ui';

const dataTable = [
  {
    fullName: 'Eric Clapton',
    born: 'Ripley, United Kingdom',
    age: 77,
  },
  {
    fullName: 'Adam Sandler',
    born: 'Brooklyn, New York, United States',
    age: 56,
  },
  {
    fullName: 'Jennifer Aniston',
    born: 'Sherman Oaks, Los Angeles, California, United States',
    age: 53,
  },
  {
    fullName: 'Ben Stiller',
    born: 'New York, New York, United States',
    age: 56,
  },
  {
    fullName: 'Brooklyn Decker',
    born: 'Dayton, Ohio, United States',
    age: 35,
  },
];

class App extends Component {
  state = {
    valueTable: dataTable,
    search: '',
    category: '',
  };

  _handleSearch = (e) => {
    this.setState({ search: e.target.value }, () => {
      setTimeout(() => {
        this._handleSearchDoc();
      }, 1000);
    });
  };

  _handleCategory = (e) => {
    this.setState({ category: e.target.value });
  };

  _handleNestedTable = (val) => {
    return (
      <tr>
        <td colSpan={5} style={{ border: '1px solid grey' }}>
          Child dari index ke - {val}
        </td>
      </tr>
    );
  };

  _handleSearchDoc = () => {
    const { search, category } = this.state;

    let searchDoc = dataTable.filter((val) => {
      if (category === '' || category === 'Fullname') {
        return val.fullName.toString().toLowerCase().includes(search.toLowerCase());
      } else if (category === 'Born') {
        return val.born.toString().toLowerCase().includes(search.toLowerCase());
      } else {
        return val.age.toString().toLowerCase().includes(search.toLowerCase());
      }
    });
    this.setState({ valueTable: searchDoc });
  };

  _handleSortUp = (val) => {};

  render() {
    return (
      <React.Fragment>
        <DataTableComponent
          headers={{
            id: 'Fullname',
            name: 'Born',
            count: 'Age',
          }}
          items={this.state.valueTable}
          onFilterCategory={this._handleCategory}
          onSortUp={this._handleSortUp}
          onSearch={this._handleSearch}
          onNestedTable={this._handleNestedTable}
          search={this.state.search}
        />
      </React.Fragment>
    );
  }
}

export default App;
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <h3><strong parentName="h3">{`Table`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the alignment of a table according to surrounding text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`background`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background image of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bgColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background color of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`border`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the width of the table border.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`caption`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Returns the `}<inlineCode parentName="td">{`<caption>`}</inlineCode>{` element of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cellPadding`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the amount of space between the cell border and cell content`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cellSpacing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the amount of space between the cells in a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the height of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the width of the table`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h3><strong parentName="h3">{`TableRow`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal alignment of the content within a table row`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bgColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background color of a table row`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns an alignment character for cells in a table row`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`chOff`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal offset of the ch property`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the height of a table row.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rowIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Returns the position of a row in the rows collection of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sectionRowIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Returns the position of a row in the rows collection of a tbody, thead, or tfoot`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`vAlign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the vertical alignment of the content within a table row`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h3><strong parentName="h3">{`HeadCell`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`abbr`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the abbr attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal alignment of the content in a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`axis`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns a comma-separated list of related data cells`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`background`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background image of a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bgColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background color of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cellIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Returns the position of a cell in the cells collection of a table row`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns an alignment character for a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`chOff`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal offset of the ch property`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colSpan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the colspan attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`headers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the headers attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the height of a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`noWrap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns whether the content in a cell can be wrapped`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rowSpan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the rowspan attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`vAlign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the vertical alignment of the content within a cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the width of a data cell`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h3><strong parentName="h3">{`HeadCell/TableCell`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`abbr`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the abbr attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal alignment of the content in a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`axis`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns a comma-separated list of related data cells`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`background`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background image of a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bgColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the background color of a table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cellIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Returns the position of a cell in the cells collection of a table row`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns an alignment character for a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`chOff`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the horizontal offset of the ch property`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colSpan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the colspan attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`headers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the headers attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the height of a data cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`noWrap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns whether the content in a cell can be wrapped`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rowSpan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the value of the rowspan attribute`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`vAlign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the vertical alignment of the content within a cell`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets or returns the width of a data cell`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h3><strong parentName="h3">{`Data Table`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`header`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set the title of the expand column`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`items`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array of Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data record array to be displayed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onFilterCategory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter menu config`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onSortUp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sorting column`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onSearch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`searching list`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onNestedTable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`nested table`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`search`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`value search`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      